import { React, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faInstagram } from "@fortawesome/free-brands-svg-icons";

import profile from "../assets/profile.svg";

const Hero = () => {
  const [loaded, setLoaded] = useState(true);
  return (
    <>
      {loaded ? (
        <div className='fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white flex flex-col items-center justify-center'>
          Loading...
        </div>
      ) : null}
      <div
        id='home'
        className='flex w-full h-screen flex-col md:flex-row gap-5 items-center justify-center text-white relative'
      >
        <div className='md:w-3/6 md:p-4'>
          <img
            data-aos='flip-right'
            data-aos-duration='1500'
            data-aos-offset='200'
            src={profile}
            alt='profile'
            onLoad={() => setLoaded(false)}
          />
        </div>
        <div
          className='md:w-3/6'
          data-aos='fade-right'
          data-aos-duration='1000'
          data-aos-offset='100'
        >
          <div className='flex flex-col w-full mt-8'>
            <h1 className='text-xl text-gray-400'>Hi, I'm</h1>
            <h1 className='text-2xl font-bold'>Mohammad Rakibul Hasan Mahin</h1>
            <p class='text-xl font-bold text-gray-300'>Student</p>
            <p className='text-md font-light text-gray-400 '>
              I am thrilled to share with you my passion for web-development and
              AI. This platform showcases my skills, experience, and
              achievements in the industry. Here, you'll find a curated
              selection of my best work that showcases my versatility,
              creativity, and attention to detail. Whether you're a potential
              employer or just someone who shares my passion, I hope that you'll
              find inspiration and insight into my work. So, feel free to browse
              and learn more about what I've been up to.
            </p>
          </div>

          <ul className='flex mt-2 gap-4 items-center'>
            <li>
              <a
                href='https://github.com/rakibul-mahin'
                rel='noreferrer'
                target='_blank'
              >
                <FontAwesomeIcon size='2xl' icon={faGithub} />
              </a>
            </li>
            <li>
              <a
                href='https://www.instagram.com/rakibul_hasan_mahin/'
                rel='noreferrer'
                target='_blank'
              >
                <FontAwesomeIcon size='2xl' icon={faInstagram} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Hero;
